var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconVilla = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "m28.45 16.4-8-6a.75.75 0 0 0-.9 0l-8 6a.75.75 0 0 0 .9 1.2l.8-.6v12c0 .41.34.75.75.75h12c.41 0 .75-.34.75-.75V17l.8.6q.21.15.45.15a.75.75 0 0 0 .45-1.35m-10.7 11.85V26c0-.14.11-.25.25-.25h4c.14 0 .25.11.25.25v2.25zm7.5 0h-1.5V26c0-.96-.79-1.75-1.75-1.75h-4c-.96 0-1.75.79-1.75 1.75v2.25h-1.5V15.87L20 11.93l5.25 3.94z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "M17.25 18v4c0 .41.34.75.75.75h4c.41 0 .75-.34.75-.75v-4c0-.41-.34-.75-.75-.75h-4c-.41 0-.75.34-.75.75m1.5.75h2.5v2.5h-2.5z"
})));
export default SvgIconVilla;